import { useState, useEffect, useMemo } from 'react';
import api from '../services/api';

let permissoesCache = null;
export function limparCachePermissoes() { permissoesCache = null; }

export function usePermissao() {
  const [permissoes, setPermissoes] = useState(permissoesCache);

  const perfil = useMemo(() => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return 'usuario';
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.perfil || 'usuario';
    } catch { return 'usuario'; }
  }, []);

  useEffect(() => {
    if (permissoesCache) { setPermissoes(permissoesCache); return; }
    api.get('/permissoes/minhas/permissoes')
      .then(r => { permissoesCache = r.data; setPermissoes(r.data); })
      .catch(() => {});
  }, []);

  const temPerm = (modulo, tipo) => {
    if (perfil === 'admin') return true;
    if (!permissoes) return false; // enquanto carrega, bloqueia
    return permissoes[modulo]?.[tipo] === true;
  };

  const menuVisivel = (menu) => {
    if (perfil === 'admin') return true;
    // Mapear chaves do menu para módulos
    const mapa = {
      dashboard: 'dashboard', clientes: 'clientes', propostas: 'propostas',
      laudos: 'laudos', agendamentos: 'os', relatorios: 'relatorios',
      configuracoes: 'configuracoes', usuarios: 'usuarios', nfse: 'fiscal',
      gestao: 'gestao', leads: 'leads', estoque: 'estoque',
      'classificacao-nr13': 'classificacao_nr13', classificacao_nr13: 'classificacao_nr13',
      templates: 'templates', 'envios-massa': 'envio_massa', envio_massa: 'envio_massa',
      boletos: 'boletos',
    };
    const modulo = mapa[menu] || menu;
    return temPerm(modulo, 'ver');
  };

  return {
    perfil,
    pode: (acao) => temPerm(acao, 'ver'),
    menuVisivel,
    podeExcluir: temPerm('clientes', 'excluir'),
    podeVerFinanceiro: perfil === 'admin' || temPerm('fiscal', 'ver'),
    podeConfiguracoes: temPerm('configuracoes', 'ver'),
    podeUsuarios: temPerm('usuarios', 'ver'),
    podeEngenheiro: perfil === 'engenheiro' || perfil === 'admin',
    temPermissao: temPerm,
  };
}
